export const CloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || "transition duration-300 hover:scale-125"}
    >
      <path
        d="M16.2199 2.38265L14.5898 0.752563L8.12728 7.21509L1.66475 0.752563L0.034668 2.38265L6.4972 8.84517L0.034668 15.3077L1.66475 16.9378L8.12728 10.4753L14.5898 16.9378L16.2199 15.3077L9.75736 8.84517L16.2199 2.38265Z"
        fill="#A1A1AA"
      />
    </svg>
  );
};
